var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDesktop = function SvgDesktop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2.5C1.72386 2.5 1.5 2.72386 1.5 3V11C1.5 11.2761 1.72386 11.5 2 11.5H14C14.2761 11.5 14.5 11.2761 14.5 11V3C14.5 2.72386 14.2761 2.5 14 2.5H2ZM0.5 3C0.5 2.17157 1.17157 1.5 2 1.5H14C14.8284 1.5 15.5 2.17157 15.5 3V11C15.5 11.8284 14.8284 12.5 14 12.5H2C1.17157 12.5 0.5 11.8284 0.5 11V3Z",
    fill: "#AD5E99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14L9.25 12H6.75L6.5 14H9.5Z",
    fill: "#AD5E99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25386 11.938C6.28514 11.6878 6.49784 11.5 6.75 11.5H9.25C9.50216 11.5 9.71486 11.6878 9.74614 11.938L9.99614 13.938C10.0139 14.0803 9.96975 14.2234 9.87484 14.3309C9.77993 14.4384 9.64342 14.5 9.5 14.5H6.5C6.35659 14.5 6.22008 14.4384 6.12516 14.3309C6.03025 14.2234 5.98608 14.0803 6.00386 13.938L6.25386 11.938ZM7.19139 12.5L7.06639 13.5H8.93361L8.80861 12.5H7.19139Z",
    fill: "#AD5E99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14C4 13.7239 4.22386 13.5 4.5 13.5H11.5C11.7761 13.5 12 13.7239 12 14C12 14.2761 11.7761 14.5 11.5 14.5H4.5C4.22386 14.5 4 14.2761 4 14Z",
    fill: "#AD5E99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.5V11C1.00074 11.265 1.10634 11.5189 1.29371 11.7063C1.48109 11.8937 1.73501 11.9993 2 12H14C14.265 11.9993 14.5189 11.8937 14.7063 11.7063C14.8937 11.5189 14.9993 11.265 15 11V9.5H1ZM8 11.5C7.90111 11.5 7.80444 11.4707 7.72221 11.4157C7.63999 11.3608 7.5759 11.2827 7.53806 11.1913C7.50022 11.1 7.49031 10.9994 7.50961 10.9025C7.5289 10.8055 7.57652 10.7164 7.64645 10.6464C7.71637 10.5765 7.80546 10.5289 7.90245 10.5096C7.99945 10.4903 8.09998 10.5002 8.19134 10.5381C8.2827 10.5759 8.36079 10.64 8.41574 10.7222C8.47068 10.8044 8.5 10.9011 8.5 11C8.5 11.1326 8.44732 11.2598 8.35355 11.3536C8.25979 11.4473 8.13261 11.5 8 11.5Z",
    fill: "#AD5E99"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDesktop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/desktop.82587481.svg";
export { ForwardRef as ReactComponent };